import { jsx } from 'react/jsx-runtime';

const SvgFormTextAlignLeft = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M5 5h14v2H5V5Zm0 4h8.75v2H5V9Zm8.75 8H5v2h8.75v-2ZM5 13h14v2H5v-2Z", clipRule: "evenodd" }) }));

export { SvgFormTextAlignLeft as default };
//# sourceMappingURL=FormTextAlignLeft.es.js.map
